<template>
  <el-dropdown v-if="userInfo" trigger="click">
    <span class="el-dropdown-link">
      <p id="topnav_user_name">{{ userInfo.name }}</p>
      <el-avatar :size="40" :src="circleUrl" />
    </span>
    <template #dropdown>
      <el-dropdown-menu class="user_menu">
        <!-- 个人信息页暂未完善，入口先隐藏（页面与路由保留，完善后恢复此菜单项）
        <el-dropdown-item @click="navigateTo('personal_information')">
          {{ $t("r.personal_information") }}
        </el-dropdown-item>
        -->
        <el-dropdown-item @click="navigateTo('managerAccount')">
          账号管理
        </el-dropdown-item>
        <el-dropdown-item divided @click="logout">
          {{ $t("r.logout") }}
        </el-dropdown-item>
      </el-dropdown-menu>
    </template>
  </el-dropdown>
  <div v-else class="user_login" @click="login">
    <p>{{ $t("r.login") }}</p>
  </div>
</template>

<script lang="ts" setup>
import store from "@/store";
import { computed, reactive, toRefs } from "vue";
import { useRouter } from "vue-router";

const router = useRouter();

// 个人信息部分
const userInfo = computed(() => store.getters["auth/managerInfo"]);

const navigateTo = (name: string) => {
  router.push({ name: name, query: { userId: userInfo.value.id } });
};

const login = () => {
  router.push({ name: "login" });
};
const logout = () => {
  store.commit("auth/clearToken");
  router.push({ name: "login" });
};

const state = reactive({
  circleUrl:
    "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
});
const { circleUrl } = toRefs(state);
</script>
<style scoped>
.el-dropdown-link {
  cursor: pointer;
  color: var(--el-color-primary);
  display: flex;
  align-items: center;
}
#topnav_user_name {
  color: black;
}
.user_menu {
  width: 100px;
}
</style>
